const intro = (
  <p>
    <strong>Vademecum</strong> to rozbudowany zbiór praktycznych informacji i
    przewodników, które ułatwiają poruszanie się po zagadnieniach związanych z
    zawodem lekarza. Znajdziesz tu odpowiedzi na pytania dotyczące formalności,
    procedur, przepisów oraz codziennej praktyki klinicznej. To niezastąpione
    źródło wiedzy zarówno dla lekarzy rozpoczynających swoją karierę, jak i dla
    doświadczonych specjalistów.
  </p>
);

const content = (
  <>
    <p>
      W sekcji <strong>Vademecum</strong> zgromadziliśmy materiały, które pomogą
      Ci w wielu aspektach pracy lekarza. Obejmują one zarówno kwestie formalne,
      takie jak procedury związane z uzyskiwaniem uprawnień, wystawianiem recept
      czy prowadzeniem dokumentacji medycznej, jak i praktyczne porady dotyczące
      codziennej pracy klinicznej. Staramy się, aby informacje były aktualne,
      rzetelne i łatwo dostępne.
    </p>
    <p>
      W <strong>Vademecum</strong> znajdziesz między innymi:
    </p>
    <ul>
      <li>
        <strong>Poradniki dotyczące dokumentacji medycznej</strong> – jak
        prawidłowo prowadzić dokumentację, jakie są wymogi formalne, jak unikać
        błędów.
      </li>
      <li>
        <strong>Informacje o e-receptach i e-zwolnieniach</strong> – krok po
        kroku, jak wystawiać e-recepty i e-zwolnienia, jakie są zasady
        refundacji, co zrobić w przypadku problemów technicznych.
      </li>
      <li>
        <strong>Przewodniki po procedurach specjalizacyjnych</strong> – jak
        wygląda proces rekrutacji na specjalizację, jakie dokumenty są
        potrzebne, jakie są terminy.
      </li>
      <li>
        <strong>Materiały dotyczące LEK i LDEK</strong> – informacje o
        egzaminach, terminy, procedury, porady dotyczące przygotowań.
      </li>
      <li>
        <strong>Wskazówki dla lekarzy przedsiębiorców</strong> – jak założyć i
        prowadzić własną praktykę, jakie są obowiązki podatkowe i ZUS, jak
        rozliczać się z NFZ.
      </li>
    </ul>
    <p>
      Naszym celem jest, aby <strong>Vademecum</strong> było miejscem, gdzie
      każdy lekarz znajdzie potrzebne informacje i wsparcie. Regularnie
      aktualizujemy treści, aby były zgodne z najnowszymi przepisami i
      wytycznymi.
    </p>
    <h3>Dlaczego warto korzystać z Vademecum?</h3>
    <ul>
      <li>
        <strong>Oszczędzasz czas</strong> – wszystkie kluczowe informacje w
        jednym miejscu, bez konieczności przeszukiwania wielu stron
        internetowych.
      </li>
      <li>
        <strong>Masz pewność aktualności danych</strong> – regularnie
        aktualizujemy treści, aby były zgodne z obowiązującymi przepisami.
      </li>
      <li>
        <strong>Zyskujesz praktyczne porady</strong> – materiały są tworzone
        przez ekspertów i praktyków, którzy dzielą się swoim doświadczeniem.
      </li>
      <li>
        <strong>Unikasz błędów</strong> – dzięki naszym przewodnikom możesz
        uniknąć problemów związanych z formalnościami i procedurami.
      </li>
    </ul>
    <p>
      <strong>Vademecum</strong> to Twój niezawodny partner w codziennej pracy
      lekarza. Korzystaj z naszych materiałów i miej pewność, że działasz
      zgodnie z prawem i najlepszą praktyką medyczną.
    </p>
  </>
);

export const vademecumDescription = { intro, content };
